import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TwoColumnsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TwoColumnsSVG;
